import { render, staticRenderFns } from "./detailStaffOfficial.vue?vue&type=template&id=57d55316&scoped=true&"
import script from "./detailStaffOfficial.vue?vue&type=script&lang=js&"
export * from "./detailStaffOfficial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d55316",
  null
  
)

export default component.exports